/* Our Bouquet – birth month plant selector.
   Works with the theme's own product form.
   Plant choices and optional personal text are saved
   as Shopify line item properties.
*/
(function () {
  "use strict";

  // Property names saved on the order.
  // Keep these in English for every storefront language.
  var isSwedish = document.documentElement.lang.toLowerCase().startsWith("sv");

var PROP_COUNT = isSwedish ? "Antal växter" : "Number of plants";
var PROP_PLANT = isSwedish ? "Växt " : "Plant ";
var PROP_PERSONAL_TEXT = isSwedish ? "Text under illustrationen" : "Personal text";
var PROP_NAME = isSwedish ? "Namn " : "Name ";

  var QUANTITIES = [2, 3, 4, 5, 6];

  var REMOVE_ICON =
    '<svg viewBox="0 0 12 12" aria-hidden="true">' +
    '<path d="M2 2l8 8M10 2l-8 8" ' +
    'stroke="currentColor" stroke-width="1.2" ' +
    'stroke-linecap="round" fill="none"/></svg>';

  function readJSON(root, selector) {
    var el = root.querySelector(selector);
    try {
      return el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      return {};
    }
  }

  function fill(str, vars) {
    return String(str || "").replace(
      /\[(\w+)\]/g,
      function (_, k) {
        return vars && k in vars ? vars[k] : "";
      }
    );
  }

  function escapeHTML(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }[c];
    });
  }

  // Match the theme's page background.
  function pageBackground(el) {
    for (
      var node = el;
      node && node.nodeType === 1;
      node = node.parentElement
    ) {
      var bg = getComputedStyle(node).backgroundColor;

      if (
        bg &&
        bg !== "transparent" &&
        !/rgba\(.*,\s*0\)$/.test(bg)
      ) {
        return bg;
      }
    }
    return "";
  }

  function OurBouquet(root) {
    if (root.__ourBouquet) return;

    root.__ourBouquet = this;

    this.root = root;
    this.t = readJSON(root, "[data-ob-strings]");
    this.variants = readJSON(root, "[data-ob-variants]");

    this.quantity = null;
    this.picks = [];
    this.nextId = 1;

    this.form = null;
    this.themeButton = null;
    this.lastVariant = null;

    // Optional personal text input.
    this.personalTextInput = root.querySelector(
      "[data-ob-personal-text]"
    );
    this.namesContainer = root.querySelector(
  "[data-ob-person-names]"
);

this.addTextCheckbox = root.querySelector("[data-ob-add-text]");
this.textFields = root.querySelector("[data-ob-text-fields]");
this.personNames = {};

    this.plants = {};
    this.order = [];

    var self = this;

    root.querySelectorAll(".ob-card").forEach(
      function (card, i) {
        var img = card.querySelector("img");

        self.plants[card.dataset.key] = {
          key: card.dataset.key,
          month: card.dataset.month,
          plant: card.dataset.plant,
          orderName:
            card.dataset.orderName ||
            (card.dataset.month + " – " + card.dataset.plant),
          img: img,
          position: i
        };

        self.order.push(card.dataset.key);
      }
    );

    var bg = pageBackground(root.parentElement);

    if (bg) {
      root.style.setProperty("--ob-bg", bg);
    }

    this.bindEvents();
    this.attachToThemeForm();
    this.render();

    // Reconnect if the theme replaces the product form.
    var pending = null;

    this.observer = new MutationObserver(function (mutations) {
      var outside = mutations.some(function (m) {
        return !root.contains(m.target);
      });

      if (!outside) return;

      clearTimeout(pending);

      pending = setTimeout(function () {
        if (
          !self.form ||
          !document.contains(self.form) ||
          !self.themeButton ||
          !document.contains(self.themeButton)
        ) {
          self.attachToThemeForm();
        }

        self.syncThemeForm();
        self.renderPurchase();
      }, 80);
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["disabled"]
    });

    // Keep selected size and price updated.
    this.poll = setInterval(function () {
      var id = self.currentVariantId();

      if (id !== self.lastVariant) {
        self.lastVariant = id;
        self.renderPurchase();
      }
    }, 400);
  }

  OurBouquet.prototype.str = function (key, vars) {
    return fill(this.t[key], vars);
  };

  OurBouquet.prototype.plural = function (key, count) {
    return this.str(
      key + (count === 1 ? "_one" : "_other"),
      { count: count }
    );
  };

  /* ---------- Theme product form ---------- */

  OurBouquet.prototype.attachToThemeForm = function () {
    var self = this;

    var forms = Array.prototype.filter.call(
      document.querySelectorAll('form[action*="/cart/add"]'),
      function (f) {
        return (
          !self.root.contains(f) &&
          !!f.querySelector('button[name="add"]')
        );
      }
    );

    var form = null;
    var button = null;

    for (var i = 0; i < forms.length && !button; i++) {
      form = forms[i];
      button = this.findSubmit(form);
    }

    if (
      this.themeButton &&
      this.themeButton !== button
    ) {
      this.themeButton.classList.remove(
        "ob-theme-atc-hidden"
      );
    }

    if (this.form && this.form !== form) {
      this.form.classList.remove("ob-theme-form");
    }

    this.form = form;
    this.themeButton = button;

    if (form && button) {
      form.classList.add("ob-theme-form");

      button.classList.add("ob-theme-atc-hidden");

      document.documentElement.classList.add(
        "ob-active"
      );
    }

    this.lastVariant = this.currentVariantId();

    this.syncThemeForm();
  };

  OurBouquet.prototype.findSubmit = function (form) {
    var b =
      form.querySelector('button[name="add"]') ||
      form.querySelector('button[type="submit"]') ||
      form.querySelector('input[type="submit"]');

    if (!b && form.id && window.CSS && CSS.escape) {
      b = document.querySelector(
        '[form="' + CSS.escape(form.id) +
        '"][type="submit"], button[form="' +
        CSS.escape(form.id) + '"][name="add"]'
      );
    }

    return b;
  };

  OurBouquet.prototype.currentVariantId = function () {
    var input =
      this.form &&
      this.form.querySelector('[name="id"]');

    return input ? String(input.value) : null;
  };

  // Sync properties to the actual Shopify product form.
  OurBouquet.prototype.syncThemeForm = function () {
    if (!this.form) return;

    var box = this.form.querySelector(
      "[data-ob-properties]"
    );

    if (!box) {
      box = document.createElement("div");

      box.setAttribute("data-ob-properties", "");
      box.hidden = true;

      this.form.appendChild(box);
    }

    var props = this.isComplete()
      ? this.properties()
      : [];

    var html = props.map(function (p) {
      return (
        '<input type="hidden" name="properties[' +
        escapeHTML(p[0]) +
        ']" value="' +
        escapeHTML(p[1]) +
        '">'
      );
    }).join("");

    if (box.innerHTML !== html) {
      box.innerHTML = html;
    }
  };

  // Properties that appear in the Shopify order.
  OurBouquet.prototype.properties = function () {
    var self = this;

    var list = [
      [PROP_COUNT, String(this.quantity)]
    ];

    this.sortedPicks().forEach(function (pk, i) {
      list.push([
        PROP_PLANT + (i + 1),
        self.plants[pk.key].orderName
      ]);
    });

    // NEW: Add personal text only when provided.
    var personalText = this.personalTextInput
      ? this.personalTextInput.value.trim().slice(0, 50)
      : "";

  if (this.addTextCheckbox && this.addTextCheckbox.checked && personalText) {
      list.push([
        PROP_PERSONAL_TEXT,
        personalText
      ]);
    }

if (this.addTextCheckbox && this.addTextCheckbox.checked) {
  this.sortedPicks().forEach(function (pk, i) {
    var name = (self.personNames[pk.id] || "")
      .trim()
      .slice(0, 50);

    if (name) {
      list.push([PROP_NAME + (i + 1), name]);
    }
  });
}

return list;
  };

  /* ---------- State helpers ---------- */

  OurBouquet.prototype.sortedPicks = function () {
    var plants = this.plants;

    return this.picks.slice().sort(function (a, b) {
      return (
        plants[a.key].position -
        plants[b.key].position ||
        a.id - b.id
      );
    });
  };

  OurBouquet.prototype.isFull = function () {
    return (
      this.quantity !== null &&
      this.picks.length >= this.quantity
    );
  };

  OurBouquet.prototype.isComplete = function () {
    return (
      this.quantity !== null &&
      this.picks.length === this.quantity
    );
  };

  /* ---------- Events ---------- */

  OurBouquet.prototype.bindEvents = function () {
    var self = this;
    var root = this.root;

if (this.addTextCheckbox && this.textFields) {
  this.textFields.hidden = !this.addTextCheckbox.checked;

  this.addTextCheckbox.addEventListener("change", function () {
    self.textFields.hidden = !self.addTextCheckbox.checked;
  });
}

    var qty = root.querySelector("[data-ob-qty]");

    qty.addEventListener("click", function (e) {
      var b = e.target.closest("[data-qty]");

      if (!b) return;

      self.quantity = Number(b.dataset.qty);

      self.render();
    });

    qty.addEventListener("keydown", function (e) {
      if (
        [
          "ArrowLeft",
          "ArrowRight",
          "ArrowUp",
          "ArrowDown"
        ].indexOf(e.key) === -1
      ) {
        return;
      }

      e.preventDefault();

      var cur = self.quantity || QUANTITIES[0];

      var i =
        QUANTITIES.indexOf(cur) +
        (
          e.key === "ArrowLeft" ||
          e.key === "ArrowUp"
            ? -1
            : 1
        );

      self.quantity = QUANTITIES[
        Math.max(
          0,
          Math.min(QUANTITIES.length - 1, i)
        )
      ];

      self.render();

      qty.querySelector(
        '[data-qty="' + self.quantity + '"]'
      ).focus();
    });

    root.querySelector(
      "[data-ob-grid]"
    ).addEventListener("click", function (e) {
      var card = e.target.closest(".ob-card");

      if (!card) return;

      if (self.quantity === null) {
        root.querySelector(
          "[data-ob-step1-desc]"
        ).classList.add("is-flash");

        qty.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });

        qty.querySelector("[data-qty]").focus({
          preventScroll: true
        });

        return;
      }

      if (self.isFull()) return;

      self.picks.push({
        id: self.nextId++,
        key: card.dataset.key
      });

      self.render();
    });

    root.querySelector(
      "[data-ob-slots]"
    ).addEventListener("click", function (e) {
      var b = e.target.closest("[data-remove]");

      if (!b) return;

      var id = Number(b.dataset.remove);

      var before = self.sortedPicks().findIndex(
        function (p) {
          return p.id === id;
        }
      );

      self.picks = self.picks.filter(
        function (p) {
          return p.id !== id;
        }
      );

      self.render();

      var btns = root.querySelectorAll(
        "[data-remove]"
      );

      var next =
        btns[
          Math.min(before, btns.length - 1)
        ] ||
        root.querySelector(".ob-card");

      if (next) {
        next.focus({ preventScroll: true });
      }
    });

    // NEW: Update Shopify properties when text changes.
    if (this.personalTextInput) {
      this.personalTextInput.addEventListener(
        "input",
        function () {
          self.syncThemeForm();
        }
      );

      this.personalTextInput.addEventListener(
        "change",
        function () {
          self.syncThemeForm();
        }
      );
    }

    
if (this.namesContainer) {
  this.namesContainer.addEventListener(
    "input",
    function (e) {
      var input = e.target.closest(
        "[data-ob-person-name]"
      );

      if (!input) return;

      self.personNames[
        input.dataset.obPersonName
      ] = input.value;

      self.syncThemeForm();
    }
  );
}

    // Add to cart through the theme's existing button.
    root.querySelector(
      "[data-ob-atc]"
    ).addEventListener("click", function () {
      if (!self.isComplete()) {
        self.renderPurchase(true);
        return;
      }

      if (!self.form || !self.themeButton) {
        self.attachToThemeForm();
      }

      if (
        !self.themeButton ||
        self.themeButton.disabled
      ) {
        return;
      }

      // Make sure the latest personal text is included.
      self.syncThemeForm();

      self.themeButton.click();
    });

    root.querySelector(
      "[data-ob-bar-btn]"
    ).addEventListener("click", function () {
      var target =
        self.quantity === null
          ? qty
          : root.querySelector("[data-ob-summary]");

      target.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    });

    // Prevent incomplete selections from being purchased.
    function guard(e) {
      if (!self.form) return;

      var inForm =
        e.type === "submit"
          ? e.target === self.form
          : (function () {
              var b =
                e.target.closest &&
                e.target.closest(
                  'button, input[type="submit"]'
                );

              return (
                b &&
                b.form === self.form &&
                (
                  b.type === "submit" ||
                  b.name === "add"
                )
              );
            })();

      if (!inForm || self.isComplete()) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      self.renderPurchase(true);

      root.querySelector(
        "[data-ob-qty]"
      ).scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }

    document.addEventListener(
      "submit",
      guard,
      true
    );

    document.addEventListener(
      "click",
      guard,
      true
    );

    // Mobile sticky bar.
    var bar = root.querySelector("[data-ob-bar]");

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(
        function (entries) {
          self.inView = entries[0].isIntersecting;
          bar.hidden = !self.inView;
        },
        {
          rootMargin: "0px 0px -20% 0px"
        }
      ).observe(
        root.querySelector(".ob-wrap")
      );
    } else {
      bar.hidden = false;
    }
  };

  /* ---------- Render ---------- */

  OurBouquet.prototype.render = function () {
    var self = this;
    var root = this.root;
    var q = this.quantity;
    var n = this.picks.length;

    root.querySelector(
      "[data-ob-step1-desc]"
    ).classList.remove("is-flash");

    root.querySelectorAll(
      "[data-qty]"
    ).forEach(function (b) {
      b.setAttribute(
        "aria-checked",
        String(Number(b.dataset.qty) === q)
      );
    });

    // Plant cards.
    var counts = {};

    this.picks.forEach(function (p) {
      counts[p.key] =
        (counts[p.key] || 0) + 1;
    });

    var blocked =
      q === null || this.isFull();

    root.querySelectorAll(
      ".ob-card"
    ).forEach(function (card) {
      var p = self.plants[card.dataset.key];
      var c = counts[p.key] || 0;

      card.classList.toggle(
        "is-picked",
        c > 0
      );

      card.setAttribute(
        "aria-disabled",
        String(blocked)
      );

      card.querySelector(
        ".ob-card-badge"
      ).textContent =
        c > 0 ? "×" + c : "";

      card.setAttribute(
        "aria-label",
        self.str("card_add_aria", {
          month: p.month,
          plant: p.plant
        }) +
        (
          c
            ? ", " +
              self.str(
                "card_selected_aria",
                { count: c }
              )
            : ""
        )
      );
    });

    // Counter.
    var counter = root.querySelector(
      "[data-ob-counter]"
    );

    counter.className =
      "ob-counter" +
      (
        q !== null && n === q
          ? " is-done"
          : ""
      ) +
      (
        q !== null && n > q
          ? " is-over"
          : ""
      );

    counter.textContent =
      q === null
        ? this.str("counter_none")
        : n > q
          ? this.str("counter_over", {
              selected: n,
              total: q
            })
          : n === q
            ? this.str("counter_done", {
                total: q
              })
            : this.str("counter_progress", {
                selected: n,
                total: q,
                remaining: q - n
              });

    // Selected plants and empty slots.
    var rows = this.sortedPicks().map(
      function (pk) {
        var p = self.plants[pk.key];

        return (
          '<li class="ob-slot">' +
          '<span class="ob-slot-thumb">' +
          self.thumb(p) +
          '</span>' +
          '<span class="ob-slot-text">' +
          '<span class="ob-slot-month">' +
          escapeHTML(p.month) +
          '</span>' +
          '<span class="ob-slot-plant">' +
          escapeHTML(p.plant) +
          '</span></span>' +
          '<button type="button" ' +
          'class="ob-remove" ' +
          'data-remove="' + pk.id + '" ' +
          'aria-label="' +
          escapeHTML(
            self.str("remove_aria", {
              month: p.month,
              plant: p.plant
            })
          ) +
          '">' +
          REMOVE_ICON +
          '</button></li>'
        );
      }
    );

    for (
      var i = 0;
      i < Math.max(0, (q || 0) - n);
      i++
    ) {
      rows.push(
        '<li class="ob-slot is-empty">' +
        escapeHTML(this.str("empty_slot")) +
        '</li>'
      );
    }

    root.querySelector(
      "[data-ob-slots]"
    ).innerHTML = rows.join("");

    var over =
      q !== null ? n - q : 0;

    var overEl = root.querySelector(
      "[data-ob-over]"
    );

    overEl.hidden = over <= 0;

    if (over > 0) {
      overEl.textContent = this.plural(
        "over_notice",
        over
      );
    }

    // Mobile bar.
    root.querySelector(
      "[data-ob-bar-text]"
    ).textContent =
      q === null
        ? this.str("bar_none")
        : counter.textContent;

    root.querySelector(
      "[data-ob-bar-thumbs]"
    ).innerHTML =
      this.sortedPicks().map(function (pk) {
        return (
          "<span>" +
          self.thumb(
            self.plants[pk.key]
          ) +
          "</span>"
        );
      }).join("");
this.renderPersonNames();
    this.syncThemeForm();
    this.renderPurchase(false);
  };

OurBouquet.prototype.renderPersonNames = function () {
  if (!this.namesContainer) return;

  var self = this;
  var picks = this.sortedPicks();
  var ids = {};

  picks.forEach(function (pk) {
    ids[pk.id] = true;
  });

  Object.keys(this.personNames).forEach(function (id) {
    if (!ids[id]) {
      delete self.personNames[id];
    }
  });

  this.namesContainer.innerHTML = picks.map(
    function (pk, i) {
      var plant = self.plants[pk.key];
      var label = plant.month + " – " + plant.plant;
      var value = self.personNames[pk.id] || "";
      var id = "ObName-" + pk.id;

      return (
        '<div class="ob-person-name-row">' +
        '<label for="' + id + '">' +
        escapeHTML(label) +
        ' (' + (i + 1) + ')' +
        '</label>' +
        '<input type="text" maxlength="50" ' +
        'autocomplete="off" ' +
        'id="' + id + '" ' +
        'data-ob-person-name="' + pk.id + '" ' +
        'placeholder="' +
        escapeHTML(
    isSwedish ? "Namn" : "Name"
        ) +
        '" value="' + escapeHTML(value) + '">' +
        '</div>'
      );
    }
  ).join("");
};
  OurBouquet.prototype.thumb = function (p) {
    if (!p.img) return "";

    var src =
      p.img.currentSrc || p.img.src;

    return (
      '<img src="' +
      escapeHTML(src) +
      '" alt="" loading="lazy">'
    );
  };

  // Selected size, price and purchase button state.
  OurBouquet.prototype.renderPurchase = function (
    emphasise
  ) {
    var root = this.root;
    var q = this.quantity;
    var n = this.picks.length;

    var variant =
      this.variants[
        this.currentVariantId()
      ] || null;

    var sizeText = variant
      ? this.str("selected_size", {
          size: variant.title,
          price: variant.price
        })
      : "";

    var sizeEl = root.querySelector(
      "[data-ob-size]"
    );

    if (sizeEl.textContent !== sizeText) {
      sizeEl.textContent = sizeText;
    }

    var soldOut =
      variant ? !variant.available : false;

    var atc = root.querySelector(
      "[data-ob-atc]"
    );

    var help = root.querySelector(
      "[data-ob-help]"
    );

    var ready =
      this.isComplete() && !soldOut;

    atc.setAttribute(
      "aria-disabled",
      String(!ready)
    );

    var text =
      soldOut
        ? this.str("sold_out")
        : q === null
          ? this.str("need_qty")
          : n < q
            ? this.plural(
                "need_more",
                q - n
              )
            : n > q
              ? this.plural(
                  "too_many",
                  n - q
                )
              : this.str("ready");

    if (help.textContent !== text) {
      help.textContent = text;
    }

    help.classList.toggle(
      "is-ok",
      ready
    );

    if (emphasise && !ready) {
      help.classList.add("is-warn");

      clearTimeout(this.warnTimer);

      this.warnTimer = setTimeout(
        function () {
          help.classList.remove("is-warn");
        },
        2400
      );
    }
  };

  function init(scope) {
    (scope || document)
      .querySelectorAll(
        "[data-our-bouquet]"
      )
      .forEach(function (el) {
        new OurBouquet(el);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        init();
      }
    );
  } else {
    init();
  }

  document.addEventListener(
    "shopify:section:load",
    function (e) {
      init(e.target);
    }
  );
})();